import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import { Chart, Search, Table } from './components'
import {
  CalendarModal,
  Period,
  Selector,
  Summary,
  DeleteModal,
} from '../../components'

// globals
import * as TYPE from '../../globals/type'
import * as constants from '../../globals/constants'

// utils
import { getFormatDate } from '../../utils/getFormatDate'
import { getPeriod } from '../../utils/getPeriod'
import { getExcelFile } from '../../utils/getExcelFile'
import { getExcelDownload } from '../../utils/getExcelDownload'
import { useAxios } from '../../utils/useAxios'

//휴무일설정 false
const daysOffSetting = false

const STAT_PERIOD_ITEM = [
  { name: '날짜', action: () => console.log('$$ 오늘') },
]

const TIME_PERIOD_ITEM = [
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '24:00',
]

export default function Stat() {
  const { fetchData, loading, data, error, isStatChart } = useAxios()
  const [startDate, setStartDate] = useState(
    moment().subtract(31, 'd').format('YYYY-MM-DD'),
  )
  const [endDate, setEndDate] = useState(
    moment().subtract(1, 'd').format('YYYY-MM-DD'),
  )

  // 탭(차트, 리스트)
  const [selectTabIdx, setSelectTabIdx] = useState(0)
  // 옵션(기존)
  const [selectOption, setSelectOption] = useState([0, 1, 2, 3, 4])

  // 옵션(수정)
  const [orderCategory, setOrderCategory] = useState(TYPE.ORDER.DEFAULT)
  const [orderStatus, setOrderStatus] = useState(TYPE.STATUS.DEFAULT)
  const [orderIncludeCancel, setOrderIncludeCancel] = useState(true)
  const [orderSearch, setOrderSearch] = useState([
    TYPE.ORDER.ALL, // 주문유형
    TYPE.STATUS.ALL, // 주문상태
    getPeriod(startDate, endDate), // 기간
  ])
  const [orderReserve, setOrderReserve] = useState(true)

  // 라디오 옵션
  const [selectRadioOpt, setSelectRadioOpt] = useState(0)

  // 모달(달력)
  const [isCalVisibleModal, setIsCalVisibleModal] = useState(false)

  // 달력 관련 state
  const [rangeDates, setRangeDates] = useState([])
  const defaultSelected = {
    to: '',
    from: '',
  }
  const [range, setRange] = useState(defaultSelected)

  const [isMobile, setIsMobile] = useState(false)

  // 요약
  const [summaryItem, setSummaryItem] = useState({
    totalPrice: 0,
    count: [
      {
        main: 0,
        sub: '주문건수',
      },
      {
        main: 0,
        sub: '주문진행건수',
      },
      {
        main: 0,
        sub: '완료건수',
      },
      {
        main: 0,
        sub: '취소건수',
      },
    ],
  })

  // 날짜별
  const [chartDateItem, setChartDateItem] = useState(null)
  // 시간별
  const [chartTimeItem, setChartTimeItem] = useState(null)

  // 차트(메뉴별)
  const [menuItem, setMenuItem] = useState({ menu: [], count: [0] })
  // 테이블
  const [tableItem, setTableItem] = useState({ total: 0, list: null })
  // 페이지네이션
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)

  // 첫 렌더링
  const [init, setInit] = useState(true)

  // 모달
  const [excelItem, setExcelItem] = useState(null)
  const [isVisibleModal, setIsVisibleModal] = useState(false)

  // 요청(요약 -> 차트)
  // 첫 조회 AND
  // 주문유형, 주문상태 바꾸고 검색할 때
  useEffect(() => {
    getStatSummary(
      startDate,
      endDate,
      orderCategory,
      orderStatus,
      //  orderReserve
    )
  }, [orderSearch])

  // 요청(차트)
  // 차트뷰(날짜,시간,메뉴,테이블) 변경
  useEffect(() => {
    if (!init && selectTabIdx === 0) {
      getStatChart(
        startDate,
        endDate,
        orderCategory,
        orderStatus,
        orderIncludeCancel,
        // orderReserve,
        getChartType(),
      )
    } else if (!init && selectTabIdx === 1) {
      getStatChart(
        startDate,
        endDate,
        orderCategory,
        orderStatus,
        orderIncludeCancel,
        // orderReserve,
        getChartType(),
        page,
        size,
      )
    }
  }, [selectTabIdx, selectRadioOpt, size, page, orderIncludeCancel])

  // 차트 타입
  const getChartType = () => {
    let chartType = 'day'

    // 테이블뷰
    if (selectTabIdx === 1) {
      chartType = 'table'
    }
    // 차트뷰
    else {
      switch (selectRadioOpt) {
        case 0:
          chartType = 'day'
          break
        case 1:
          chartType = 'time'
          break
        case 2:
          chartType = 'menu'
          break

        default:
          break
      }
    }

    return chartType
  }

  // 요약 조회
  const getStatSummary = (
    start, // 시작일
    end, // 마감일
    category, // 주문유형(전체, 배달, 픽업)
    status, // 주문상태(전체, 완료, 취소)
    // reserve, // 사전예약
  ) => {
    const params = {
      startDate: moment(start).format('YYYY-MM-DD'), // 시작일
      endDate: moment(end).format('YYYY-MM-DD'), // 종료일

      ...((category === TYPE.ORDER.DELIVERY ||
        category === TYPE.ORDER.PICK_UP) && {
        orderType: category === TYPE.ORDER.DELIVERY ? 'D' : 'P',
      }), // 주문유형

      ...((status === TYPE.STATUS.COMPLETE ||
        status === TYPE.STATUS.CANCEL ||
        status === TYPE.STATUS.PROGRESS) && { orderStatus: status }), // 주문상태

      // ...(reserve && { detailType: 'R' }), // 사전예약(제거)
    }

    fetchData(
      constants.API.STAT_SUMMARY,
      'GET', // method
      null, // body
      params, // params
    )
  }

  // 차트 조회
  const getStatChart = (
    start, // 시작일
    end, // 종료일
    category, // 주문유형(전체, 배달, 픽업)
    status, // 주문상태(전체, 완료, 취소)
    cancel, // 취소포함여부
    // reserve, // 사전예약
    type, // 차트 종류
    page, // 테이블 페이지
    size, // 테이블 사이즈
  ) => {
    const params = {
      startDate: moment(start).format('YYYY-MM-DD'), // 시작일
      endDate: moment(end).format('YYYY-MM-DD'), // 종료일

      ...((category === TYPE.ORDER.DELIVERY ||
        category === TYPE.ORDER.PICK_UP) && {
        orderType: category === TYPE.ORDER.DELIVERY ? 'D' : 'P',
      }), // 주문유형

      ...((status === TYPE.STATUS.COMPLETE ||
        status === TYPE.STATUS.CANCEL ||
        status === TYPE.STATUS.PROGRESS) && { orderStatus: status }), // 주문상태

      orderIncludeCancel: cancel ? 'Y' : 'N', // 취소포함(차트)

      // ...(reserve && { detailType: 'R' }), // 사전예약(제거)

      type, // 타입(차트, 테이블)
      page, // 페이지(테이블)
      size, // 사이즈(테이블)
    }

    fetchData(
      constants.API.STAT_CHART,
      'GET', // method
      null, // body
      params, // params
    )
  }

  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData

    switch (resCode) {
      // 성공(데이터 O)
      case TYPE.API_RESPONSE.SUCCESS:
        // 엑셀
        if (resData?.hasOwnProperty('statExcel')) {
          getExcelDownload(resData.statExcel, resData.fileName)
        }
        // 요약
        // 요약을 조회해서 데이터가 있는 경우 차트를 조회
        // 데이터 없는 경우는 차트 조회하지 않음
        else if (resData?.hasOwnProperty('totalStat')) {
          const {
            totalPrice,
            totalOrderCount,
            totalProgressCount,
            totalCompleteCount,
            totalCancelCount,
          } = resData?.totalStat

          // 변경
          setSummaryItem({
            totalPrice: totalPrice ?? 0,
            count: [
              {
                main: totalOrderCount ?? 0,
                sub: '주문건수',
              },
              {
                main: totalProgressCount ?? 0,
                sub: '주문진행건수',
              },
              {
                main: totalCompleteCount ?? 0,
                sub: '완료건수',
              },
              {
                main: totalCancelCount ?? 0,
                sub: '취소건수',
              },
            ],
          })

          // 차트 조회
          getStatChart(
            startDate,
            endDate,
            orderCategory,
            orderStatus,
            orderIncludeCancel,
            // orderReserve,
            getChartType(),
            page,
            size,
          )

          // 기존
          // const { first, second, third, fourth } = filterSummaryText()
          // 주문상태에 따라 요약에 표시되는 텍스트가 유동적
          // setSummaryItem({
          //   totalPrice: resData?.totalStat?.totalPrice ?? 0,
          //   count: fourth
          //     ? [
          //         { main: resData.totalStat.totalOrderCount, sub: first }, // 주문건수
          //         {
          //           main: resData.totalStat[filterSummaryData(2)],
          //           sub: second,
          //         }, // 사전예약건수 or 완료(취소)건수
          //         {
          //           main: resData.totalStat[filterSummaryData(3)] ?? 0,
          //           sub: third,
          //         }, // 완료(취소)건수 or 완료(취소)율
          //         {
          //           // 완료율
          //           main:
          //             filterSummaryData(4) === '0'
          //               ? (
          //                   (resData.totalStat.orderSuccessCount /
          //                     resData.totalStat.totalOrderCount) *
          //                   100
          //                 ).toFixed(1)
          //               : // 취소율
          //               filterSummaryData(4) === '1'
          //               ? (
          //                   (resData.totalStat.orderFailCount /
          //                     resData.totalStat.totalOrderCount) *
          //                   100
          //                 ).toFixed(1)
          //               : // 나머지
          //                 resData.totalStat[filterSummaryData(4)] ?? 0,
          //           sub: fourth,
          //         },
          //         // 취소건수 or 완료(취소)율
          //       ]
          //     : [
          //         { main: resData.totalStat.totalOrderCount, sub: first },
          //         {
          //           main: resData.totalStat[filterSummaryData(2)] ?? 0,
          //           sub: second,
          //         },
          //         {
          //           main:
          //             filterSummaryData(3) === '0'
          //               ? resData.totalStat?.orderSuccessCount
          //                 ? (
          //                     (resData.totalStat.orderSuccessCount /
          //                       resData.totalStat.totalOrderCount) *
          //                     100
          //                   ).toFixed(1) ?? 0
          //                 : 0
          //               : // 취소율
          //               filterSummaryData(3) === '1'
          //               ? resData.totalStat?.orderFailCount
          //                 ? (
          //                     (resData.totalStat.orderFailCount /
          //                       resData.totalStat.totalOrderCount) *
          //                     100
          //                   ).toFixed(1) ?? 0
          //                 : 0
          //               : // 나머지
          //                 resData.totalStat[filterSummaryData(3)] ?? 0,
          //           sub: third,
          //         },
          //       ],
          // })
        }
        // 차트
        else {
          let period = getPeriod(startDate, endDate, 'YYYY-MM-DD')
          let date = []
          let count = []

          // 날짜별
          if (resData?.dayStatList) {
            for (let i = 0; i < period.length; i++) {
              let foundItem = resData?.dayStatList.find(
                (e) => e.date === period[i],
              )

              date.push(moment(period[i]).format('M.D'))
              count.push(foundItem ? foundItem.orderCount : 0)
            }

            setChartDateItem({ period: date, count })
          }

          // 시간별
          else if (resData?.timeStatList) {
            for (let i = 0; i < TIME_PERIOD_ITEM.length; i++) {
              let foundItem = resData?.timeStatList.find(
                (e) => e.hour === TIME_PERIOD_ITEM[i],
              )

              count.push(foundItem ? foundItem.orderCount : 0)
            }
            date.push(...TIME_PERIOD_ITEM)

            setChartTimeItem({ period: date, count })
          }

          // 메뉴별
          else if (resData?.menuStatList) {
            for (let i = 0; i < resData.menuStatList.length; i++) {
              date.push(resData.menuStatList[i]?.menuName ?? '')
              count.push(resData.menuStatList[i].orderCount)
            }

            setMenuItem({ menu: date, count })
          }

          // 테이블
          else if (resData?.dataList) {
            setTableItem({ total: resData.dataCount, list: resData.dataList })
          }
        }

        break

      // 성공(데이터 X)
      case TYPE.API_RESPONSE.NOT_DATA:
        // 요약은 데이터 있고 차트가 없는 경우
        // 취소 차트에서 취소 제외하기 선택
        // 요약 유지, 차트만 초기화
        if (isStatChart) {
          initChartState()
        }
        // 요약 데이터 없음
        // 요약, 차트 초기화
        else {
          initState()
        }

        break

      // 실패
      case TYPE.API_RESPONSE.FAILURE:
      default:
        break
    }

    setInit(false)
  }, [data])

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 480)
  }

  // 화면 리사이즈 날짜 포맷 변경
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleTab = (flag) => {
    setOrderIncludeCancel(true)
    setSelectTabIdx(flag)
  }

  const handleOption = (index) => {
    if (selectOption.includes(index)) {
      let filtering = selectOption.filter((ele) => ele !== index)

      setSelectOption(filtering)
    } else {
      setSelectOption([...selectOption, index])
    }
  }

  // 주문유형, 주문상태 선택
  const handleSearchOption = (select, type) => {
    if (type === 0) {
      setOrderCategory(select)
    } else {
      setOrderStatus(select)
    }
  }

  // 라디오 선택
  const handleRadioOption = (idx) => {
    setSelectRadioOpt(idx)
  }

  // 요약 API 데이터 필터링
  const filterSummaryData = (number) => {
    switch (number) {
      // 2번째: 사전예약건수 or 완료(취소)건수
      case 2:
        // 사전예약 체크
        if (orderReserve) {
          return 'preBookingCount'
        }

        // 주문상태, 전체
        if (
          orderStatus === TYPE.STATUS.DEFAULT ||
          orderStatus === TYPE.STATUS.ALL
        ) {
          return 'orderSuccessCount'
        }

        // 완료 체크
        if (orderStatus === TYPE.STATUS.ORDER_RECEIPT) {
          return 'orderSuccessCount'
        }
        // 취소
        return 'orderFailCount'

      // 3번째: 완료(취소)건수 or 완료(취소)율
      case 3:
        // 사전예약 체크
        if (orderReserve) {
          // 주문상태, 전체
          if (
            orderStatus === TYPE.STATUS.DEFAULT ||
            orderStatus === TYPE.STATUS.ALL
          ) {
            return 'orderSuccessCount'
          }

          // 완료
          if (orderStatus === TYPE.STATUS.ORDER_RECEIPT) {
            return 'orderSuccessCount'
          }

          // 취소
          else {
            return 'orderFailCount'
          }
        }
        // 사전예약 미체크
        else {
          // 주문상태, 전체
          if (
            orderStatus === TYPE.STATUS.DEFAULT ||
            orderStatus === TYPE.STATUS.ALL
          ) {
            return 'orderFailCount'
          }
          // 완료
          if (orderStatus === TYPE.STATUS.ORDER_RECEIPT) {
            return '0' // 완료율
          }
          // 취소
          else {
            return '1' // 취소율
          }
        }

      // 취소건수 or 완료(취소)율
      case 4:
        // 주문상태, 전체
        if (
          orderStatus === TYPE.STATUS.DEFAULT ||
          orderStatus === TYPE.STATUS.ALL
        ) {
          return 'orderFailCount'
        }
        // 완료
        if (orderStatus === TYPE.STATUS.ORDER_RECEIPT) {
          return '0' // 완료율
        }
        // 취소
        else {
          return '1' // 취소율
        }

      default:
        return
    }
  }

  // 요약 텍스트 필터링(기존)
  const filterSummaryText = () => {
    // 요약
    let first = `${
      orderCategory === TYPE.ORDER.ALL || orderCategory === TYPE.ORDER.DEFAULT
        ? ''
        : orderCategory
    }주문건수`

    let second = orderReserve
      ? `${TYPE.ORDER.RESERVE} 건수`
      : `${
          orderCategory === TYPE.ORDER.ALL ||
          orderCategory === TYPE.ORDER.DEFAULT
            ? ''
            : orderCategory
        }${
          orderStatus === TYPE.STATUS.CANCEL_COMPLETE
            ? TYPE.STATUS.CANCEL_COMPLETE
            : TYPE.STATUS.ORDER_RECEIPT
        }건수`

    let third = orderReserve
      ? `${
          orderCategory === TYPE.ORDER.ALL ||
          orderCategory === TYPE.ORDER.DEFAULT
            ? ''
            : orderCategory
        }${
          orderStatus === TYPE.STATUS.CANCEL_COMPLETE
            ? TYPE.STATUS.CANCEL_COMPLETE
            : TYPE.STATUS.ORDER_RECEIPT
        }건수`
      : orderStatus === TYPE.STATUS.DEFAULT || orderStatus === TYPE.STATUS.ALL
      ? `${
          orderCategory === TYPE.ORDER.DEFAULT ||
          orderCategory === TYPE.ORDER.ALL
            ? ''
            : orderCategory
        }${TYPE.STATUS.CANCEL_COMPLETE}건수`
      : orderStatus === TYPE.STATUS.ORDER_RECEIPT
      ? `${
          orderCategory === TYPE.ORDER.DEFAULT ||
          orderCategory === TYPE.ORDER.ALL
            ? ''
            : orderCategory
        }${TYPE.STATUS.ORDER_RECEIPT}율`
      : `${
          orderCategory === TYPE.ORDER.DEFAULT ||
          orderCategory === TYPE.ORDER.ALL
            ? ''
            : orderCategory
        }${TYPE.STATUS.CANCEL_COMPLETE}율`

    let fourth = orderReserve
      ? orderStatus === TYPE.STATUS.DEFAULT || orderStatus === TYPE.STATUS.ALL
        ? `${
            orderCategory === TYPE.ORDER.DEFAULT ||
            orderCategory === TYPE.ORDER.ALL
              ? ''
              : orderCategory
          }${TYPE.STATUS.CANCEL_COMPLETE}건수`
        : orderStatus === TYPE.STATUS.ORDER_RECEIPT
        ? `${
            orderCategory === TYPE.ORDER.DEFAULT ||
            orderCategory === TYPE.ORDER.ALL
              ? ''
              : orderCategory
          }${TYPE.STATUS.ORDER_RECEIPT}율`
        : `${
            orderCategory === TYPE.ORDER.DEFAULT ||
            orderCategory === TYPE.ORDER.ALL
              ? ''
              : orderCategory
          }${TYPE.STATUS.CANCEL_COMPLETE}율`
      : null

    return { first, second, third, fourth }
  }

  // 검색
  const handleSearch = () => {
    setPage(1)
    setOrderSearch([orderCategory, orderStatus, getPeriod(startDate, endDate)])
  }

  const selectRangeDate = () => {
    const yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD')

    // 아무것도 선택 안한 경우
    if (!range?.to && !range?.from) return setIsCalVisibleModal(false)
    // 하나만 선택
    else if (!range?.to && range?.from) {
      // 기간 제한
      if (
        !moment(moment(range.from).format('YYYY-MM-DD')).isSameOrBefore(
          yesterday,
        )
      ) {
        alert('어제까지의 기간만 조회가 가능합니다.')
      } else {
        setStartDate(range.from)
        setEndDate(range.from)
      }
    }
    // 모두 선택
    else if (getFormatDate(range.from) && getFormatDate(range.to)) {
      const startMoment = moment(moment(range.from).format('YYYY-MM-DD'))
      const endMoment = moment(moment(range.to).format('YYYY-MM-DD'))

      const isWithinOneYear = endMoment.diff(startMoment, 'years') < 1

      const isStartBeforeOneYearAgo = startMoment.isBefore(
        moment().subtract(1, 'year'),
      )
      const isEndBeforeOneYearAgo = endMoment.isBefore(
        moment().subtract(1, 'year'),
      )

      // 기간 제한(종료일: 어제)
      if (
        !startMoment.isSameOrBefore(yesterday) ||
        !endMoment.isSameOrBefore(yesterday)
      ) {
        alert('어제까지의 기간만 조회가 가능합니다.')
      }
      // 기간 제한(시작 ~ 종료: 1년)
      else if (
        !isWithinOneYear ||
        isStartBeforeOneYearAgo ||
        isEndBeforeOneYearAgo
      ) {
        alert('어제로부터 1년간의 기간만 조회가 가능합니다.')
      } else {
        setStartDate(range.from)
        setEndDate(range.to)
      }
    }

    setIsCalVisibleModal(false)
  }

  const handleSetModal = () => {
    // 디폴트 날짜 세팅
    setRange({
      from: new Date(startDate),
      to: new Date(endDate),
    })

    setIsCalVisibleModal(true)
  }

  const handleReserve = () => {
    if (orderCategory === TYPE.ORDER.DELIVERY) return

    setOrderReserve(!orderReserve)
  }

  const handleExcel = () => {
    const params = {
      startDate,
      endDate,
      ...((orderCategory === TYPE.ORDER.DELIVERY ||
        orderCategory === TYPE.ORDER.PICK_UP) && {
        orderType: orderCategory === TYPE.ORDER.DELIVERY ? 'D' : 'P',
      }),
      ...((orderStatus === TYPE.STATUS.COMPLETE ||
        orderStatus === TYPE.STATUS.CANCEL ||
        orderStatus === TYPE.STATUS.PROGRESS) && {
        orderStatus: orderStatus,
      }),

      // ...(orderReserve && { detailType: 'R' }),
    }

    // 기존
    // getExcelFile(
    //   constants.API.STAT_EXCEL,
    //   null,
    //   params,
    //   `통계_테이블_${moment().format('YYYYMMDD')}`,
    // )

    // 변경
    fetchData(
      constants.API.STAT_EXCEL,
      'GET', // method
      null, // body
      params, // params
    )
  }

  const handleTableSize = (num) => {
    setSize(num)
    setPage(1)
  }

  // 배달 선택 시 사전예약 비활성화
  useEffect(() => {
    if (orderCategory === TYPE.ORDER.DELIVERY) {
      setOrderReserve(false)
    }
  }, [orderCategory])

  const openModal = (item) => {
    setExcelItem(item)
    setIsVisibleModal(true)
  }

  const closeModal = () => {
    setExcelItem(null)
    setIsVisibleModal(false)
  }

  const initState = () => {
    // 요약
    setSummaryItem({
      totalPrice: 0,
      count: [
        {
          main: 0,
          sub: '주문건수',
        },
        {
          main: 0,
          sub: '진행주문건수',
        },
        {
          main: 0,
          sub: '완료건수',
        },
        {
          main: 0,
          sub: '취소건수',
        },
      ],
    })

    // 차트, 테이블
    initChartState()
    setTableItem({ total: 0, list: null })
  }

  const initChartState = () => {
    setChartDateItem(null)
    setChartTimeItem(null)
    setMenuItem({ menu: [], count: [0] })
  }

  const handleCheckBox = () => {
    setOrderIncludeCancel(!orderIncludeCancel)
  }

  return (
    <>
      <Container>
        <Period
          dateText={'날짜 직접 선택'}
          isSearch={true}
          isReserve={true}
          isReserveSelect={orderReserve}
          setReserve={handleReserve}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          periodItem={STAT_PERIOD_ITEM}
          periodAction={() => console.log('$$ periodAction')}
          selectedIndex={0}
          setSelectedIndex={() => console.log('$$ setSelectedIndex')}
          isDisableReserve={orderCategory === TYPE.ORDER.DELIVERY}
          handleSetModal={handleSetModal}
        >
          <Search
            orderCategory={orderCategory}
            orderStatus={orderStatus}
            handleSearchOption={handleSearchOption}
            handleSearch={handleSearch}
          />
        </Period>
        <Summary
          detailStats={summaryItem?.count}
          titleLabel={'총 금액'}
          titleStat={`${
            summaryItem?.totalPrice
              ? summaryItem?.totalPrice?.toLocaleString()
              : 0
          }원`}
        />
        <Wrapper>
          <Selector
            leftText={'차트뷰'}
            rightText={'테이블뷰'}
            selectedIdx={selectTabIdx}
            handleTab={handleTab}
          />
        </Wrapper>

        {selectTabIdx === 0 ? (
          <Chart
            isMobile={isMobile}
            selectOption={selectOption}
            selectRadioOpt={selectRadioOpt}
            orderSearch={orderSearch}
            chartDateItem={chartDateItem}
            chartTimeItem={chartTimeItem}
            startDate={startDate}
            endDate={endDate}
            menuItem={menuItem}
            orderIncludeCancel={orderIncludeCancel}
            handleRadioOption={handleRadioOption}
            handleCheckBox={handleCheckBox}
          />
        ) : (
          <Table
            loading={loading}
            item={tableItem}
            size={size}
            setSize={handleTableSize}
            page={page}
            setPage={setPage}
            handleExcel={(item) => openModal(item)}
            // handleExcel={handleExcel}
          />
        )}
      </Container>

      <CalendarModal
        title={'날짜'}
        show={isCalVisibleModal}
        handleClose={() => setIsCalVisibleModal(false)}
        handleSubmit={selectRangeDate}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        range={range}
        setRange={setRange}
        rangeDates={rangeDates}
        setRangeDates={setRangeDates}
        daysOffSetting={daysOffSetting}
      />

      <DeleteModal
        show={isVisibleModal}
        message={'엑셀 파일을 다운로드 하시겠습니까?'}
        buttons={['취소', '확인']}
        handleClose={() => {
          closeModal()
        }}
        handleSubmit={() => {
          handleExcel()
          closeModal()
        }}
      />
    </>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  display: flex;
  flex-direction: row;
`
